module.exports = "<p>\n  test-page works!\n</p>\n"